export const businessConstant = {
  adMessageMaxLength: 120,
}

export default businessConstant
